import { Component } from '@angular/core';

@Component({
  selector: 'lib-risk-assessment-complete',
  templateUrl: './risk-assessment-complete.component.html',
  styleUrls: ['./risk-assessment-complete.component.scss']
})
export class RiskAssessmentCompleteComponent {

  constructor() {
  }
}
